<template>
  <div>
    <div class="header">
      <h4 class="normal" v-html="getResource('acc_pwd_change')"></h4>
    </div>
    <el-form :model="form">
      <el-form-item label prop="password" :error="errors.password">
        <el-input type="password" v-model="form.password" :placeholder="getResource('reg_pass')"></el-input>
      </el-form-item>
      <el-form-item label prop="password_confirmation">
        <el-input
          type="password"
          v-model="form.password_confirmation"
          :placeholder="getResource('reg_pass_again')"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-row type="flex" justify="end">
          <el-col style="width: auto">
            <el-button type="primary" @click="save" v-html="getResource('acc_save_data')"></el-button>
          </el-col>
        </el-row>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      form: {},
      errors: {}
    };
  },
  methods: {
    save() {
      axios
        .post('/' + window.lang + '/user/passchange' + window.location.search, this.form)
        .then(response => {
          console.log(response.data);
          if (response.data.status) {
            this.$emit('password-changed');
          }
        })
        .catch(error => {
          console.error(error);
          let e = {};
          _.forEach(error.response.data.errors, (errArray, key) => {
            e[key] = errArray[0];
          });
          this.errors = e;
        });
    },
    getResource(key) {
      return $r[key];
    }
  }
};
</script>
